import { MessageCircle } from "lucide-react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "./ui/accordion";
import { Reveal, SectionHeading } from "./Reveal";
import { WHATSAPP_URL } from "../constants/site";
import { useLang } from "../i18n/LangContext";

const Faq = () => {
    const { t } = useLang();
    return (
    <section data-testid="faq-section" className="wine-section py-24 sm:py-32">
        <div className="mx-auto grid max-w-7xl gap-14 px-4 sm:px-8 lg:grid-cols-12 lg:gap-20 lg:px-12">
            <div className="lg:col-span-5">
                <SectionHeading
                    index={t.faq.index}
                    eyebrow={t.faq.eyebrow}
                    title={
                        <>
                            {t.faq.titleA}<span className="italic text-gold">{t.faq.titleB}</span>{t.faq.titleC}
                        </>
                    }
                />
                <Reveal delay={0.22}>
                    <p className="mt-7 max-w-sm text-base leading-relaxed text-taupe">
                        {t.faq.side}
                    </p>
                </Reveal>
                <Reveal delay={0.3}>
                    <a
                        data-testid="faq-cta-whatsapp"
                        href={WHATSAPP_URL}
                        target="_blank"
                        rel="noreferrer"
                        className="group mt-8 inline-flex items-center gap-3 rounded-full bg-gold px-7 py-3.5 text-sm font-medium text-noir transition-all duration-300 hover:scale-[1.03] hover:bg-burnt"
                    >
                        <MessageCircle className="h-4 w-4 transition-transform duration-300 group-hover:-rotate-12" />
                        {t.faq.cta}
                    </a>
                </Reveal>
            </div>

            <Reveal delay={0.15} className="lg:col-span-7">
                <Accordion type="single" collapsible className="w-full">
                    {t.faq.items.map((faq, i) => (
                        <AccordionItem
                            key={faq.q}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border-b border-beige/12"
                        >
                            <AccordionTrigger
                                data-testid={`faq-trigger-${i}`}
                                className="py-6 text-left font-serif text-lg text-cream transition-colors hover:text-gold hover:no-underline sm:text-xl"
                            >
                                {faq.q}
                            </AccordionTrigger>
                            <AccordionContent
                                data-testid={`faq-content-${i}`}
                                className="pb-6 text-sm leading-relaxed text-taupe sm:text-base"
                            >
                                {faq.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </Reveal>
        </div>
    </section>
    );
};

export default Faq;
